import { GuidelinesToolbarGroup } from '~/features/editor/GuidelinesToolbarGroup';
import { FramingPanel } from '~/features/framing/FramingPanel';
import { Divider, ToolbarRow, UndoRedoGroup } from './parts';

export function SpriteToolbar() {
  return (
    <ToolbarRow>
      <UndoRedoGroup />
      <Divider />
      <FramingPanel />
      <Divider />
      <GuidelinesToolbarGroup />
    </ToolbarRow>
  );
}
